import { api } from './index';

const CnaesRequestService = {
  getList() {
    return api.get('cnaes/list');
  },
  getValues(type, params) {
    return api.get('cnaes/values/'+type, params);
  },
  getValuesByAddressState(params) {
    return api.get('cnaes/values-by-address-state', params);
  },
  getValuesByResale(params) {
    return api.get('cnaes/values-by-resale', params);
  },
  getValuesByManufacturers(params) {
    return api.get('cnaes/values-by-manufacturers', params);
  },
  getListManufacturers() {
    return api.get('cnaes/list-manufacturers');
  },
  getSectionByCompany(params) {
    return api.get('cnaes/section-by-company', params);
  },
  getListResales() {
    return api.get('cnaes/list-resales');
  },
  getOthersValues(params) {
    return api.get('cnaes/others-values', params);
  },
};

export default CnaesRequestService;
